/**
 * Dokleja prefix bazy SPA (`import.meta.env.BASE_URL`) do absolutnych
 * ścieżek `/api/...` zwracanych przez backend (np. `GalleryItem.imageUrl` z F16).
 *
 * Powód: backend trzyma URL bez prefixu (`/api/gallery/files/<uuid>.webp`).
 * Przy `base: '/'` w Vite (subdomena `crm.tatanga.eu`) helper jest no-op,
 * ale zostawiamy go na przyszłość, gdyby aplikacja kiedyś znowu trafiła
 * pod sub-path (np. `/crm/`).
 */
export function assetUrl(url: string | null | undefined): string {
  if (!url) return '';
  if (url.startsWith('/api/')) {
    const base = import.meta.env.BASE_URL.replace(/\/$/, '');
    return base + url;
  }
  return url;
}
